export default {
    baseStyle: {
        attributeBox: {
            spacing: 1.5,
            flex: 1,
            select: {
                width: {base: 'max-content', lg: '30%'},
                height: '35px',
                bg: 'gray.10',
                borderColor: 'gray.125',
                _focusVisible: {
                    borderColor: 'gray.125',
                    outline: 'none'
                },
                _hover: {
                    borderColor: 'gray.125',
                    outline: 'none'
                },
                cursor: 'default',
                _disabled: {
                    opacity: 1,
                    cursor: 'default'
                }
            },
            quantity: {
                marginTop: 2,
                text: {
                    fontSize: 'sm',
                    color: 'gray.700'
                }
            },
            promotion: {
                alignItems: 'center',
                popover: {
                    marginleft: 2
                },
                textColor: {
                    color: 'green.700'
                },
                textSize: {
                    fontSize: 'sm'
                }
            }
        },
        ecoText: {
            flexDirection: 'column',
            alignItems: 'end',
            textAlign: 'end',
            width: '60%'
        },
        ecoTaxText: {
            width: {base: '115px', sm: '100%'},
            color: 'gray.675',
            fontSize: '12px',
            lineHeight: '16px'
        },
        flexBox: {
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }
    }
}
